<template>
  <div class="ruleBox">
    <div class="left" />
    <div class="right" />
    <!--<img src="https://static.didapinche.com/pics/g/coupontemplate_connectline.png" alt="" class="left-linkicon">-->
    <!--<img src="https://static.didapinche.com/pics/g/coupontemplate_connectline.png" alt="" class="right-linkicon">-->
    <!--    <div class="ruleBox-title">活动规则</div>-->
    <div class="ruleBox-rule" v-html="ruleData" />
  </div>
</template>

<script>
  export default {
    name: 'RuleBox',
    props: ['ruleData'],
    data() {
      return {
        // ruleTxt: '很抱歉为你带来不愉快的出行体验，嘀嗒出行坚决不允许司机以任何恶劣态度对待乘客。\n\n1.建议避免与司机产生正面冲突，防止事态恶化；\n\n2.如果情况紧急，危及到人身安全，请立即拨打安全专线或者一键报警，嘀嗒安全专线 400-108-1999 保持7*24小时在线，时刻关注你的出行安全，一键报警页面提供车辆及行程信息，便于你更快地了解和告诉警方有效信息；\n\n3.如果非人身安全，请点击订单进行投诉，并保留部分证据（发票、录音、截图）等，我们会第一时间对涉事司机进行处理；\n\n4.你也可以查看司机服务监督卡号，联系其所在出租车公司进行反馈投诉；\n\n5.对于司机服务问题，嘀嗒出行有严格的司机规范管理条例，将对涉事司机进行扣减行为分、暂停接单、封禁、永久封禁等多种处罚，详情请查阅：出租车司机行为分管理规范。'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ruleBox {
    width: 100%;
    /*height: 1rem;*/
    position: relative;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.1rem 0.28rem 0 rgba(0, 0, 0, 0.15);
    border-radius: 0.26rem;
    margin-top: 0.24rem;
    position: relative;
  }
  .left {
    position: absolute;
    left: 0.38rem;
    top: -0.48rem;
    width: 0.12rem;
    height: 0.8rem;
    background: url("https://static.didapinche.com/pics/g/coupontemplate_connectline.png") no-repeat;
    background-size: 100%;
  }

  .right {
    position: absolute;
    right: 0.32rem;
    top: -0.48rem;
    width: 0.12rem;
    height: 0.8rem;
    background: url("https://static.didapinche.com/pics/g/coupontemplate_connectline.png") no-repeat;
    background-size: 100%;
  }

  .left-linkicon {
    display: block;
    width: 0.11rem;
    /*height: 0.8rem;*/
    position: absolute;
    left: 0.38rem;
    top: -0.5rem;
  }

  .right-linkicon {
    display: block;
    width: 0.11rem;
    /*height: 0.8rem;*/
    position: absolute;
    right: 0.32rem;
    top: -0.5rem;
  }
  .ruleBox-title{
    padding: 0.5rem 0 0 0.44rem;
    font-size: 0.32rem;
    font-weight: bold;
    color: #292D39;
  }
  .ruleBox-rule{
    padding: 0.32rem 0.4rem 0.76rem 0.4rem;
    color: #4E556C;
    font-size: 0.28rem;
    line-height: 0.4rem;
    white-space: pre-wrap;
    /deep/ p img{
      width: 100%
    }
  }
</style>
